import { render, staticRenderFns } from "./sup-self-restraint.vue?vue&type=template&id=41104236&scoped=true"
import script from "./sup-self-restraint.vue?vue&type=script&lang=js"
export * from "./sup-self-restraint.vue?vue&type=script&lang=js"
import style0 from "./sup-self-restraint.vue?vue&type=style&index=0&id=41104236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41104236",
  null
  
)

export default component.exports